// extracted by mini-css-extract-plugin
module.exports = {"errorIconCol":"ErrorDisplay_errorIconCol__7x-U6","statusCodeDisplay":"ErrorDisplay_statusCodeDisplay__3ZdA3"};